import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import {useState} from 'react';
import {User} from '@cp/model';
import useSetDisableAnimation from '../../../hooks/users/useSetDisableAnimation';

export interface GeneralSettingsAnimationProps {
  user?: User | null;
}

export default function GeneralSettingsAnimation({user}: GeneralSettingsAnimationProps) {
  const [error, setError] = useState<string | null>(null);

  const {setDisableAnimation, loading} = useSetDisableAnimation();

  const handleToggleAnimation = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    setError(null);

    try {
      await setDisableAnimation(newValue);
    } catch {
      // Error is handled by the hook's onError callback
    }
  };

  return (
    <>
      <FormControlLabel
        control={
          <Switch checked={user?.disableAnimation || false} onChange={handleToggleAnimation} disabled={loading} />
        }
        label={
          <Box>
            <Typography variant="body1">Disable Animations</Typography>
            <Typography variant="body2" color="text.secondary">
              Turn off animations throughout the application for better performance
            </Typography>
          </Box>
        }
        sx={{alignItems: 'flex-start', mb: 3}}
      />

      {/* Error Message for Animation */}
      {error && (
        <Typography variant="body2" color="error" sx={{mt: 2, mb: 3}}>
          {error}
        </Typography>
      )}
    </>
  );
}
